export default "/images/vendor/@coreui/icons/svg/flag/cif-mg.svg?86af48f2e8d43ae039f58d218f78b6b6";